import BaseGetters from '@/store/base/getters'

export default BaseGetters({
  //
})
